import { useEffect, useState } from 'react';
import AdminCard from '../../../components/admin/AdminCard';
import useProject from '../hooks/useProject';
import useProjectShowroomInfo from '../hooks/useProjectShowroomInfo';
import ProjectShowroomInfoForm from './ProjectShowroomInfoForm';
import { ProjectShowroomInfo } from '../models/investors';
import { useNavigate } from 'react-router-dom';

interface Props {
  projectId: string;
}

type ShowroomInfoForm = Omit<ProjectShowroomInfo, 'image'>;

const ProjectShowroomInfoCard = ({ projectId }: Props) => {
  const { doProjectInfo } = useProject();
  const { doUpdateShowroomInfo } = useProjectShowroomInfo();
  const navigate = useNavigate();

  const [showroomInfo, setShowroomInfo] = useState<ShowroomInfoForm | null>(
    null,
  );
  const [loaded, setLoaded] = useState(false);

  const loadProject = async () => {
    const project = await doProjectInfo(projectId);
    if (project?.showroom_info) {
      const { image, ...rest } = project.showroom_info;
      setShowroomInfo(rest);
    }
    setLoaded(true);
  };

  useEffect(() => {
    loadProject().then().catch();
  }, [projectId]);

  const handleForm = async (form: ShowroomInfoForm) => {
    const result = await doUpdateShowroomInfo(projectId, form);
    if (result === 200) navigate(0);
  };

  return (
    <AdminCard
      title="Información del Showroom"
      children={
        loaded ? (
          <ProjectShowroomInfoForm
            projectId={projectId}
            showroomInfo={showroomInfo}
            handleForm={handleForm}
          />
        ) : (
          <p>Cargando...</p>
        )
      }
    />
  );
};

export default ProjectShowroomInfoCard;
